import { RadioButtonOption } from "../../../common/enums";

export const TAKE2_CHECKLIST_VERSION_2026_02 = 1;

export type Take2Checklist = {
    checklistVersion: number | undefined;
    rightPlaceAndEquipment: RadioButtonOption;
    haveUnderstoodInstructions: RadioButtonOption;
    haveReadPermitAndTerms: RadioButtonOption;
    haveProtectionEquipment: RadioButtonOption;
    haveEquipment: RadioButtonOption;
    isNearbyWork: RadioButtonOption;
    equipmentIsDrainedAndNoPreassure: RadioButtonOption;
    dutySwitchIsDisconnected: RadioButtonOption;
    riskOfBurnsCrushCuts: RadioButtonOption;
    riskOfFallsOrFallingObjects: RadioButtonOption;
    needsBlockingOff: RadioButtonOption;
    hasAppropriateScaffolding: RadioButtonOption;
    riskOfFire: RadioButtonOption;
    riskObservationDateTime: string;
    riskObservationLocation: string;
    whatRTO: string;
    riskObservationNotifier: string;
    riskObservationCourseOfEvents: string;
    riskObservationCauseDescription: string;
    riskObservationFixSuggestion: string;

    whichProcessEquipmentMediaDescription: string;
    whereIsClosestEyeWashAndShowerDescription: string;
    whereIsClosestAlarmEquipmentDescription: string;
    whereIsClosestExtinguishingEquipmentDescription: string;

    knowWhereClosestAlarmEquipmentIs: RadioButtonOption;
    haveKnowledgeOfProcessEquipmentMedia: RadioButtonOption;
    needsWorkplaceBlockingOff: RadioButtonOption;
    knowWhereClosestEyeWashAndShowerIs: RadioButtonOption;
    hasFireRisk: RadioButtonOption;
    knowWhereClosestExtinguishingEquipmentIs: RadioButtonOption;
};
